/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_TitleInputs */

const en_business_form_title = /** @type {(inputs: Business_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in Touch`)
};

const es_business_form_title = /** @type {(inputs: Business_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponte en contacto`)
};

/**
* | output |
* | --- |
* | "Get in Touch" |
*
* @param {Business_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_title = /** @type {((inputs?: Business_Form_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_title(inputs)
	return en_business_form_title(inputs)
});